import { render, staticRenderFns } from "./ProjectsPanelProjectList.vue?vue&type=template&id=dcdfed58&scoped=true&"
import script from "./ProjectsPanelProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelProjectList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPanelProjectList.vue?vue&type=style&index=0&id=dcdfed58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdfed58",
  null
  
)

export default component.exports